export var SENTRY_RELEASE = "8fa66fddadde0331791660c4a610c9ebd81cac46";
